module.exports = __webpack_public_path__ + "static/media/comment-alt-dots.16d7e735.svg";